export class Cor {
  id: number;
  cor: string;
  ativo: boolean;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/cores/cor.model.ts
 **/